import { useEffect } from "react"

/**
 * Locks body scroll while the calling component is mounted.
 * Prevents iOS Safari scroll-through on fullscreen modal pages.
 */
export function useBodyScrollLock() {
  useEffect(() => {
    const prev = document.body.style.overflow
    document.body.style.overflow = "hidden"
    return () => { document.body.style.overflow = prev }
  }, [])
}
